import "./UploadVideo.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProgressBar from "react-bootstrap/ProgressBar";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import VideoUploadForm from "./VideoUploadForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useContext, useState, useEffect } from "react";
import { ProfileContext } from "../../context/profile";
import { Link } from "react-router-dom";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { usersAllChannelsFetcher } from "../../api/requests";

const UploadVideo = () => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const { profile } = useContext(ProfileContext);
  const user = Cookies.get("vaghfnamaUser");
  const history = useHistory();
  const [userChannels, setUserChannels] = useState([]);
  const { id } = useParams();

  const getAllUsersChannels = async () => {
    if (profile.user) {
      try {
        setUserChannels(await usersAllChannelsFetcher.get(profile.user));
      } catch (err) {
        console.error(err);
        setUserChannels([]);
      }
    }
  };

  useEffect(() => {
    getAllUsersChannels();
  }, [profile.user]);

  const handleUploadClick = () => {
    setLoading(true);
  };

  return (
    <>
      <ContentWrapper>
        <Container
          fluid
          className="upload-details"
          style={{
            // maxWidth: "1500px",
            minHeight: "88.7vh",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          {user ? (
            <VideoUploadForm
              handleUploadClick={handleUploadClick}
              loading={loading}
              setLoading={setLoading}
              userChannels={userChannels}
              progress={progress}
              setProgress={setProgress}
              channelId={id}
            />
          ) : (
            history.push("/auth/login")
          )}

          {loading && (
            <div
              style={{
                paddingTop: "30px",
                paddingLeft: "30px",
                paddingRight: "30px",
              }}
            >
              <hr />
              <Row>
                <Col lg={12}>
                  <div className="rtlByMe">
                    <HeadingWrapper heading="بارگزاری جزئیات" />
                  </div>
                </Col>
                <Col lg={2} style={{ marginBottom: "25px" }}>
                  <div className="imgplace"></div>
                </Col>

                <Col lg={10} style={{ textAlign: "right" }}>
                  <div className="osahan-title">در حال ارسال...</div>
                  <div className="osahan-progress">
                    <ProgressBar striped animated now={progress} />

                    <div className="osahan-close">
                      <a
                        onClick={() => {
                          setLoading(false);
                          setProgress(0); // Reset progress
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon icon={faTimesCircle} />
                      </a>
                    </div>
                  </div>
                  <div className="osahan-desc">
                    ویدئو درحال بارگزاری می باشد، لطفا صفحه را نبندید.
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Container>
        <ThinFooter />
      </ContentWrapper>
    </>
  );
};

export default UploadVideo;
